import React from 'react'
import {
  WrapperButtonGeneralSumary,
  WrapperGeneralSumary,
  TextGeneralSumary
} from './ButtonGeneralSumary.styles'
import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { useLocation } from 'react-router-dom'
import { ADMIN_ROOT_PATH, ADMIN_SUMMARY_REPORT_V3_PATH } from 'routes/paths'
import { useTranslation } from 'i18n'

const ButtonGeneralSumary = () => {
  const { t } = useTranslation()

  const location = useLocation()
  const isSummaryPath = location.pathname === ADMIN_ROOT_PATH

  const handleClick = () => {
    window.location.href = ADMIN_SUMMARY_REPORT_V3_PATH
  }

  return (
    <div className="flex flex-col gap-2">
      <WrapperButtonGeneralSumary
        onClick={handleClick}
        className={isSummaryPath ? 'bg-gray-700' : 'bg-gray-900'}
      >
        <WrapperGeneralSumary>
          <FontIcon
            iconName="chart-pie"
            color={tokens.colors.livrosMedium}
            size={20}
          />
          <TextGeneralSumary>{t('Resumo')}</TextGeneralSumary>
        </WrapperGeneralSumary>
      </WrapperButtonGeneralSumary>
    </div>
  )
}

export default ButtonGeneralSumary
